import { Component, Inject, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-show-all-table-dialog',
  templateUrl: './show-all-table-dialog.component.html',
  styleUrls: ['./show-all-table-dialog.component.scss']
})
export class ShowAllTableDialogComponent implements OnInit {

  constructor(  
  @Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: FormBuilder,
  private cd: ChangeDetectorRef,
  private translateService: TranslateService,
  private dialog: MatDialogRef<ShowAllTableDialogComponent>) { }
  isCancel = false;

  ngOnInit() {
  }

  sortData(sort: Sort) {
    const data = this.data.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data.data = data;
      return;
    }

    this.data.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';


      for (let i = 0; i < this.data.TABLECONFIG.length; i++) {
        if (sort.active === this.data.TABLECONFIG[i].key) {
          //data is an array of strings, not an array of objects
          const alpha = isNaN(parseFloat(a[i])) ? a[i] : parseFloat(a[i]);
          const beta = isNaN(parseFloat(b[i])) ? b[i] : parseFloat(b[i]);
          return this.compare(alpha, beta, isAsc);
        }
      }
    });

  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
